import odata from '@bingads-webui-component-legacy/http/channel/odata';

async function postTask({
  BlobName, fileName, TaskType, UploadDateTime = null, BookingCount = 0, IsProdEnv = true,
}) {
  const odataOptions = {
    cacheResponse: false,
    url: '/Customers(:advertisercustomer_id)/Accounts(:account_id)/TaskItems?$expand=TaskItemExecutions',
    data: {
      '@odata.type': '#Model.PpsReconciliationReportUploadTaskItem',
      Name: 'PpsReconciliationReportUpload',
      Type: IsProdEnv ? 'PpsReconciliationReportUpload' : 'PpsReconciliationReportUploadTest',
      Cron: '',
      NotificationType: 'Always',
      NotificationMedium: 'Email',
      // PSTTimezoneId: 71,
      ModifiedAt: null,
      // RequestId: Math.random().toString().substr(2),
      FileIdentifier: BlobName,
      TaskType,
      UploadedFileName: fileName,
      UploadDateTime,
      BookingCount,
    },
  };

  const res = await odata.post(odataOptions);
  return res;
}

export const getBlobUploadUrl = async ({ extension = 'csv' }) => {
  const odataOptions = {
    cacheResponse: false,
    url: `/BulkUploadFiles/GetBlobUploadUrl(CustomerId=:advertisercustomer_id,BulkFileType=20,FileExtension=.${extension})`,
  };

  const res = await odata.get(odataOptions);
  return res;
};

export const postPreviewTask = async ({ BlobName, fileName, IsProdEnv }) => {
  const res = await postTask({
    BlobName, fileName, TaskType: 'Preview', IsProdEnv,
  });
  return res;
};

export const postCommitTask = async ({
  BlobName, fileName, UploadDateTime, BookingCount, IsProdEnv,
}) => {
  const res = await postTask({
    BlobName, fileName, TaskType: 'Commit', UploadDateTime, BookingCount, IsProdEnv,
  });
  return res;
};

export const pollExecutionResult = ({ id }) => {
  const odataOptions = {
    cacheResponse: false,
    url: `/Customers(:advertisercustomer_id)/Accounts(:account_id)/TaskItemExecutions(${id})`,
  };

  return new Promise((resolve) => {
    const timer = setInterval(() => {
      odata.get(odataOptions).then((res) => {
        if (res.Status === 'Completed' || res.Status === 'Failed') {
          clearInterval(timer);
          resolve(res);
        }
      });
    }, 5000);
  });
};

